import React from 'react'

import { Icon, Loading } from '@fourthwall/components'
import { SpotifyIcon } from '@fourthwall/icons'

import * as S from './SyncingBar.styled'

type SyncingBarProps = {
  loading?: boolean
}

export const SyncingBar = ({ loading }: SyncingBarProps) => (
  <Loading isLoading={loading}>
    <S.Container>
      <S.IconContainer>
        <Icon component={SpotifyIcon} height={20} />
      </S.IconContainer>
      <div>
        <S.Status>
          <S.Title>Syncing to Spotify</S.Title>
        </S.Status>
        <S.Info>
          Your podcast has been submitted. It will take about an hour before it’s visible on
          Spotify.
        </S.Info>
      </div>
    </S.Container>
  </Loading>
)
